import zipObject from 'lodash/zipObject';

const queueTypeSuffixes = [
  'CaseManagerVisitLimit',
  'FollowUpLimit',
  'IntakeLimit',
  'PeerVisitLimit',
  'ReengagementLimit',
  'CaseRateIntakesOnly',
] as const;

/** The settings to show in each column of the Global section */
export const globalSettingNames = queueTypeSuffixes.map(suffix => `global${suffix}`);

/** The states we can control queues for */
export const stateCodePrefixes = ['AK', 'CO', 'MI', 'NC', 'NM', 'OH', 'OR', 'WA'] as const;

/** The kinds of state-specific queues we have */
const stateQueueTypeSuffixes = ['FollowUpLimit', 'IntakeLimit', 'ReengagementLimit'] as const;

/** The names of the various state-specific queue settings, organized by state */
export const stateSettingNames = zipObject(
  stateCodePrefixes,
  stateCodePrefixes.map(state => stateQueueTypeSuffixes.map(suffix => `${state}${suffix}`)),
);
